
import { Component, Vue } from 'vue-property-decorator';

@Component({
  watch: {
    windowWidth(newWidth, oldWidth) {
      if (oldWidth > 992 && newWidth < 992) {
        (this as any).limit = 1;
        (this as any).loadRequests(1, (this as any).currentSort);
      } else if (oldWidth < 992 && newWidth > 992) {
        (this as any).limit = 5;
        (this as any).loadRequests(1, (this as any).currentSort);
      }
    },
    dashboardData(newVal, oldVal) {
      const header = newVal.header;

      (this as any).monthSummary = {
        solicitud: {
          ...(this as any).monthSummary.solicitud,
          value: header.pendingRequests,
          pendingCancellationEndorsement: {
            value: header.pendingCancellationEndorsement
          }
        },
        endoso: {
          ...(this as any).monthSummary.endoso,
          value: header.pendingEndorsementWithoutMovements
        },
        endosoMov: {
          ...(this as any).monthSummary.endosoMov,
          value: header.pendingEndorsementWithMovements
        },
        siniestro: {
          ...(this as any).monthSummary.siniestro,
          value: header.pendingClaims
        },
        siniestroPago: {
          ...(this as any).monthSummary.siniestroPago,
          value: header.pendingPayments
        },
      };
    },
    mobileCurrentMonthSummary(newVal, oldVal) {
      switch (newVal) {
        case 'solicitud':
          (this as any).filter.modifyType = 0;
          (this as any).loadRequests(1, (this as any).currentSort);
          break;
        case 'endoso':
          (this as any).filter.modifyType = 1;
          (this as any).loadRequests(1, (this as any).currentSort);
          break;
        case 'endosoMov':
          (this as any).filter.modifyType = 2;
          (this as any).loadRequests(1, (this as any).currentSort);
          break;
        case 'siniestro':
          (this as any).filter.modifyType = -1;
          (this as any).loadRequests(1, (this as any).currentSort);
          break;
        //TODO: Revisar el modifyType
        case 'siniestroPago':
          (this as any).filter.modifyType = -1;
          (this as any).loadRequests(1, (this as any).currentSort);
          break;
      }
    },
  },
  components: {
    Comments: () => import('@/views/admin/dashboard/Comments.vue'),
    RequestsGraphs: () => import('@/views/admin/dashboard/RequestsGraphs.vue'),
    ClaimsGraphs: () => import('@/views/admin/dashboard/ClaimsGraphs.vue'),
    MonthSummary: () => import('@/views/admin/dashboard/MonthSummary.vue'),
    Summary: () => import('@/views/admin/dashboard/Summary.vue'),
  },
  computed: {
    username() {
      return (this as any).$store.state.user.fullname;
    },
  },
  filters: {},
})
export default class Dashboard extends Vue {
  monthSummary: any = {
    solicitud: {
      type: 0,
      value: 0,
      label: 'Solicitudes Pendientes',
      width: {},
      pendingCancellationEndorsement: {
        value: 0,
        width: {},
      },
    },
    endoso: {
      type: 1,
      value: 0,
      label: 'Endosos Sin Mov. Pendientes',
      width: {},
    },
    endosoMov: {
      type: 2,
      value: 0,
      label: 'Endosos Con Mov. Pendientes',
      width: {},
    },
    siniestro: {
      type: -1,
      value: 0,
      label: 'Siniestros Pendientes de Aprobacion',
      width: {},
    },
    siniestroPago: {
      type: -1,
      value: 0,
      label: 'Siniestros Pendientes de Pago',
      width: {},
    },
  };
  mobileCurrentMonthSummary: string = 'solicitud';
  filter: any = {
    controlZoneId: '',
    month: '',
    year: '',
    reporttype: '',
    branchId: '',
    trimester: '',
    status: '',
    code: '',
    requestNumber: '',
    seguredName: '',
    modifyType: 0,
    policy_number: '',
  };
  // filterGraphs = {}
  limit: number = 5;
  totalRows: number = 0;
  currentSort: Record<string, string> = {
    col: 'requests.order',
    dir: 'asc',
  };
  adminRoles: any = [];
  requests: any = [];
  requestsOperationsLimit: number = 5;
  claimsOperationsLimit: number = 5;
  commentsLimit: number = 3;
  windowWidth: number = 0;
  dashboardData: any = {};
  ready = false;
  isReinsurer = false;
  requestsGraphFilters: any = {
    requestsPerBusiness: {
      currency: 1,
      validity: 1,
    },
    requestsPerBranch: {
      currency: 1,
      validity: 1,
    },
    countRequestsPerBranch: {
      currency: 1,
      validity: 1,
    },
  };
  claimsGraphFilters: any = {
    claimsPerBusiness: {
      currency: 1,
      validity: 1,
    },
    claimsPerBranch: {
      currency: 1,
      validity: 1,
    },
    countClaimsPerBranch: {
      currency: 1,
      validity: 1,
    },
  };

  async mounted() {
    if (window.innerWidth < 992) {
      this.limit = 1;
    } else {
      this.limit = 5;
    }

    await this.loadAdminRoles();
    this.isReinsurer =
      this.$store.state.user.type == this.adminRoles.REASEGURADOR;

    await this.loadRequests(1, this.currentSort);
    await this.loadDashboardData();
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth;
      });
    });
  }
  async getClaimsFilters(filters) {
    this.claimsGraphFilters = { ...filters };
    await this.loadDashboardData();
  }
  async getRequestsFilters(filters) {
    this.requestsGraphFilters = { ...filters };
    await this.loadDashboardData();
  }
  async seeMoreComments() {
    this.commentsLimit = this.commentsLimit + 3;
    await this.loadDashboardData();
  }
  async seeMoreRequestsOperations() {
    this.requestsOperationsLimit = this.requestsOperationsLimit + 5;
    await this.loadDashboardData();
  }
  async seeMoreClaimsOperations() {
    this.claimsOperationsLimit = this.claimsOperationsLimit + 5;
    await this.loadDashboardData();
  }
  async loadRequests(page: number, sort: Record<string, string>) {
    this.currentSort = sort;
    if (this.$store.state.user.type == this.adminRoles.REASEGURADOR) {
      this.filter.companyIds = this.$store.state.user.companies.join(',');
    }
    const response: any = await (this.$root as any)._post('requests/all', {
      limit: this.limit,
      page: page,
      order: this.currentSort,
      models: 'companies,currencies',
      ...this.filter,
    });
    this.totalRows = response.totalRows;
    this.requests = response.data;
  }
  async loadDashboardData() {
    const response: any = await (this.$root as any)._post('admins/dashboard', {
      lastCommentsLimit: this.commentsLimit,
      requestsApprovedPerClientLimit: this.limit,
      requestsOriginalGrossAonPerClientLimit: this.limit,
      requestsOriginalGrossAonPerBranchLimit: this.limit,
      requestsApprovedPerBranchLimit: this.limit,
      requestsLastOperationsLimit: this.requestsOperationsLimit,
      claimsApprovedPerClientLimit: this.limit,
      claimsApprovedPerBranchLimit: this.limit,
      claimsLastOperationsLimit: this.claimsOperationsLimit,
      requestsGraphFilters: this.requestsGraphFilters,
      claimsGraphFilters: this.claimsGraphFilters,
    });

    this.dashboardData = response;
    // console.log("this.dashboardData",this.dashboardData);
  }
  async loadAdminRoles() {
    const response: any = await (this.$root as any)._get('admins/getroles');
    this.adminRoles = response;
  }
  async handleModifyType(modifyType) {
    this.filter.modifyType = modifyType;
    await this.loadRequests(1, this.currentSort);
  }
  handleMobileCurrentMonthSummary(value) {
    this.mobileCurrentMonthSummary = value;
  }
  handleLimit(limit) {
    this.limit = limit;
  }
}
